import React from 'react'
import { useSelector } from 'react-redux'
import './styles.scss'
import close from './../../images/close-white.svg'

const ModalDocuments = ( props ) => {

    return (
        <div className="static-modal">
            <div className="modal extra-small">
                <div className="content">
                    <div className="icons-wrap">
                        <img src={ close } alt="Zamknij" onClick={ () => props.closeModal() } />
                    </div>
                    <div className="col">
                        <div className="text roman">
                            <h2>Dokumenty finansowe niezbędne do zawarcia umowy</h2>
                            <h3>Pełna księgowość</h3>
                            <ul>
                                <li>Rachunek Zysków i Strat</li>
                                <li>Bilans</li>
                            </ul>
                            <h3>Księgowość uproszczona</h3>
                            <ul>
                                <li>Księga Przychodów i Rozchodów</li>
                                <li>Deklaracja PIT</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalDocuments;